<template>
  <div id="Login" class="view">
    <div class="switch-label">
      <span>Ny bruker?</span>
      <label class="switch">
        <input type="checkbox" v-model="isRegistering">
        <span class="slider"></span>
      </label>
    </div>
    <form class="fields" v-on:submit.prevent="submit">
      <input type="email" autocomplete="email" name="email" v-model="email" placeholder="E-post" />
      <transition name="fade">
        <input v-if="!forgotPassword" type="password" autocomplete="current-password" name="password" v-model="password" placeholder="Passord" />
      </transition>
      <transition name="fade">
        <input v-if="isRegistering" type="password" name="password_repeat" :class="password_repeat.length ? (password_repeat === password ? 'valid' : 'invalid') : ''" v-model="password_repeat" placeholder="Bekreft passord" />
      </transition>
      <transition name="fade">
        <p v-if="error" class="is_error">{{error}}</p>
      </transition>
      <div class="switch-label">
        <span><small>Jeg aksepterer <a href="https://thaugland.no/personvern/" target="_blank">personvern og bruksvilkår</a></small></span>
        <label class="switch">
          <input type="checkbox" v-model="accept">
          <span class="slider"></span>
        </label>
      </div>
      <button class="submit btn" @click="submit" :disabled="!accept || isDisabled">{{submitText}}</button>
    </form>
    <div class="switch-label">
      <span>Glemt passord?</span>
      <label class="switch">
        <input type="checkbox" v-model="forgotPassword">
        <span class="slider"></span>
      </label>
    </div>
    <Loader :visible="loading" />
  </div>
</template>

<script>
/* Helpers */
import { auth } from '@/fire'
/* Components */
import Loader from '@/components/Loader.vue'

export default {
  name: 'Login',
  props: ['newUser'],
  data () {
    return {
      STATES: {
        default: 1,
        isRegistering: 2,
        forgotPassword: 3,
      },

      email: this.newUser || '',
      password: '',
      password_repeat: '',
      accept: false,

      error: '',
      state: this.newUser ? 2 : 1,
      loading: false,
    }
  },
  components: {
    Loader,
  },
  computed: {
    isDisabled () {
      return (!this.forgotPassword && this.password.length < 6) ||
        !this.isEmail(this.email) ||
        (this.isRegistering && this.password !== this.password_repeat)
    },
    forgotPassword: {
      get () {
        return this.state === this.STATES.forgotPassword
      },
      set (on) {
        this.state = on ? this.STATES.forgotPassword : this.STATES.default
      },
    },
    isRegistering: {
      get () {
        return this.state === this.STATES.isRegistering
      },
      set (on) {
        this.state = on ? this.STATES.isRegistering : this.STATES.default
      },
    },
    submitText () {
      switch (this.state) {
        case this.STATES.isRegistering: return 'Registrer'
        case this.STATES.forgotPassword: return 'Tilbakestill'
        default: return 'Logg inn'
      }
    },
  },
  watch: {
    password_repeat (val) {
      if (this.error && val === this.password) this.error = ''
    },
  },
  methods: {
    onError (error) {
      console.warn(error)
      switch (error.code) {
        case 'auth/user-not-found':
          this.error = 'Bruker finnes ikke'
          break
        case 'auth/wrong-password':
          this.error = 'Passordet er ugyldig'
          break
        case 'auth/email-already-in-use':
          this.error = 'Bruker finnes alerede'
          break
        default:
          this.error = error.message
      }
      this.loading = false
    },
    submit () {
      if (this.loading) return
      this.error = ''
      this.loading = true
      if (this.email) {
        if (this.forgotPassword) {
          this.resetPassword()
        } else if (this.password) {
          if (this.isRegistering) this.register()
          else this.signin()
        } else {
          this.error = 'Fyll ut passord'
          this.loading = false
        }
      } else {
        this.error = 'Fyll ut e-post'
        this.loading = false
      }
    },
    clear () {
      this.error = ''
      this.loading = false
      this.password = ''
      this.password_repeat = ''
      this.state = this.newUser ? 2 : 1
    },
    signin () {
      auth.signInWithEmailAndPassword(this.email, this.password).then(this.clear.bind(this)).catch(this.onError.bind(this))
    },
    register () {
      if (this.password === this.password_repeat) {
        auth.createUserWithEmailAndPassword(this.email, this.password).then(() => {
          this.clear()
          auth.currentUser.sendEmailVerification().then(() => {
            this.$toasted.show('Vennligst bekreft e-postadressen din')
          }, (error) => {
            console.error(error)
          })
        }).catch(this.onError.bind(this))
      } else {
        this.error = 'Passordene er ikke like'
      }
    },
    resetPassword () {
      auth.sendPasswordResetEmail(this.email).then(() => {
        alert('Tilbakestille passordet', 'Sjekk e-posten din for å tilbakestille passordet ditt')
        this.loading = false
      }).catch((error) => {
        console.error(error)
        this.error = 'Kunne ikke tilbakestille passordet'
        this.loading = false
      })
    },
    isEmail (value) {
      if (value.length < 7) return false
      const reg = /^.*@.*(\.\w{2,3})+$/
      return !!reg.test(value)
    },
  },
  mounted () {
    this.clear()
  },
}
</script>

<style lang="scss">
#Login {
  background: var(--offwhite);

  input[type="password"] {
    &.valid {
      border-color: lime;
    }
    &.invalid {
      border-color: orangered;
    }
  }
}
</style>
